"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Authenticated = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var events = _interopRequireWildcard(require("../../constants/events"));

var _tokens = require("../../utils/tokens");

var _hooks = require("../../hooks");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Authenticated = function Authenticated(props) {
  var children = props.children; // pull the authManager from AuthContext

  var authManager = (0, _hooks.useAuthManager)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      shouldRender = _useState2[0],
      setShouldRender = _useState2[1];

  var onStateChange = function onStateChange() {
    if (authManager !== null) {
      setShouldRender((0, _tokens.isTokensValid)(authManager.getTokens()));
    }
  };

  (0, _react.useEffect)(function () {
    if (authManager !== null) {
      // on mount we run authenticate
      authManager.authenticate().then(function () {
        onStateChange();
        authManager.on(events.USER_FOUND, onStateChange);
        authManager.on(events.LOAD_USER_ERROR, onStateChange);
        authManager.on(events.USER_SIGNED_OUT, onStateChange);
        authManager.on(events.SESSION_TERMINATED, onStateChange);
      }).catch(function () {
        onStateChange();
      }); // on unmount, we remove our listeners

      return function () {
        authManager.removeListener(events.USER_FOUND, onStateChange);
        authManager.removeListener(events.LOAD_USER_ERROR, onStateChange);
        authManager.removeListener(events.USER_SIGNED_OUT, onStateChange);
        authManager.removeListener(events.SESSION_TERMINATED, onStateChange);
      };
    }
  }, []);
  return shouldRender ? children : null;
};

exports.Authenticated = Authenticated;
Authenticated.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)])
};
Authenticated.defaultProps = {
  children: null
};
var _default = Authenticated;
exports.default = _default;